import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import { Typography } from '@stories/Elements/Typography/Typography.styles';
import styled, { css } from 'styled-components';

const Container = styled.div``;

const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: flex;
  background-color: rgba(0, 0, 0, 0.5);
`;

const ModalWrapper = styled.div`
  background-color: ${brand.white};
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 20px;
  max-width: 1050px;

  @media ${from(Device.TabletLarge)} {
    padding: 20px 40px 40px 40px;
  }
`;

const CloseButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
  margin-bottom: 20px;
  margin-left: auto;

  svg {
    height: 30px;
    transform: rotate(45deg);
    cursor: pointer;
  }
`;

const SplitContainer = styled.div`
  @media ${from(Device.Tablet)} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 35px;
  }
`;

const Title = styled(Typography.H4)``;

const Subtitle = styled(Typography.PSmall)`
  ${fonts.helvetica['53-extended']}
  line-height: 24px;
`;

const ContentContainer = styled.div``;

const SplitIconContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 35px 1fr;
  gap: 15px;
  margin-top: 20px;
`;

const IconWrapper = styled.a<{ highlightOnHover?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: column;
  padding: 5px;
  transition: background-color 0.25s;
  color: ${brand.black};

  ${({ highlightOnHover }) =>
    highlightOnHover &&
    css`
      &:hover {
        background-color: ${brand.red.dark};
        cursor: pointer;
        ${() => Icon} {
          svg {
            g {
              fill: ${brand.white};
            }
          }
        }

        ${() => IconText} {
          color: ${brand.white};
        }
      }
    `}
`;

const IconText = styled(Typography.P)`
  ${fonts.helvetica['63-medium-extended']}
  text-align: center;
  text-transform: uppercase;
  padding: 10px 0px;
  && {
    line-height: 17px;
  }
`;

const Icon = styled.div`
  display: flex;
  margin: auto;
  svg,
  img {
    max-height: 100px;
    max-width: 100px;
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
`;

const OrContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  &::before,
  &::after {
    content: '';
    width: 2px;
    height: 100%;
    background-color: ${brand.black};
  }
`;

const Or = styled.span`
  text-transform: uppercase;
  padding: 10px 0px;
`;

const SideImage = styled.img`
  @media ${until(Device.Tablet)} {
    display: none;
  }
  margin: auto;
`;

export const TryThemOnStyles = {
  Container,
  ModalContainer,
  ModalWrapper,
  SplitContainer,
  Title,
  CloseButtonWrapper,
  Subtitle,
  ContentContainer,
  SplitIconContainer,
  IconWrapper,
  Icon,
  IconText,
  OrContainer,
  Or,
  SideImage,
};
